import 'vanilla-cookieconsent/dist/cookieconsent.css';
import '../styles/reset.css';
import '../styles/loader.css';
import '../styles/base.css';
import '../styles/legal.css';
import '../styles/consent.css';

import { fetchMicrocopyOnly, parseRichText } from './contentful';
import {
  getMicrocopySlots,
  onError,
  useDarkMode,
  localizeLegalLinks,
} from './utils';
import { resolveLocale, getLanguageCode } from './locale';
import { LEGAL_PAGES, legalPageFromPath } from './constants';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import initConsent from './consent';

// Which legal page this URL is: a public slug in either language, a
// prerendered file name, or `?page=` on the dev server, which has no rewrites.
const getPage = () => {
  const params = new URLSearchParams(window.location.search);
  const pageParam = params.get('page');
  if (pageParam && LEGAL_PAGES[pageParam]) return pageParam;
  return legalPageFromPath(window.location.pathname) || 'impressum';
};

const replaceMicrocopy = (microcopy) => {
  getMicrocopySlots().forEach((slot) => {
    const value = microcopy[slot.id];
    if (!value) {
      console.error(`No microcopy found for "${slot.id}"`);
      return;
    }
    slot.innerHTML = parseRichText(value);
  });
};

const setMeta = (key, value) => {
  const el = document.querySelector(`meta[${key}]`);
  if (el) el.setAttribute('content', value);
};

const initPage = ({ microcopy, locale }) => {
  const page = getPage();
  const pageConfig = LEGAL_PAGES[page];

  const title = microcopy[pageConfig.titleKey];
  const content = microcopy[pageConfig.contentKey];

  if (!title || !content) {
    console.error(`Missing content for legal page: ${page}`);
    window.location.replace('/');
    return;
  }

  const titleText = documentToPlainTextString(title);
  document.getElementById('page-title').textContent = titleText;
  document.getElementById('page-content').innerHTML = parseRichText(content);

  document.title = `${titleText} | HINTERLAND software`;
  setMeta('property="og:title"', `${titleText} | HINTERLAND software`);
  setMeta('property="og:url"', window.location.href.split('?')[0]);

  const description = documentToPlainTextString(content).slice(0, 160);
  setMeta('property="og:description"', description);
  setMeta('name="description"', description);

  document.documentElement.lang = getLanguageCode(locale);

  replaceMicrocopy(microcopy);
  localizeLegalLinks(getLanguageCode(locale));

  document.getElementById('year').textContent = new Date().getFullYear();

  document.querySelector('div.loading-screen').classList.add('hidden');
  document.documentElement.classList.remove('no-js');

  initConsent(getLanguageCode(locale));
};

const init = () => {
  const { locale, redirectTo } = resolveLocale();
  if (redirectTo) {
    window.location.replace(redirectTo);
    return new Promise(() => {});
  }
  document.documentElement.lang = getLanguageCode(locale);
  return fetchMicrocopyOnly(locale)
    .then((microcopy) => ({ microcopy, locale }))
    .then(initPage);
};

try {
  useDarkMode();
  init().catch(onError);
} catch (error) {
  onError(error);
}
